import React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './scrollable_area.module.css';

type ScrollableAreaStyles = {
  background: string;
  container: string;
};

const themedStyles: ThemedStyles<ScrollableAreaStyles> = {
  [Theme.DAYLIGHT]: {
    background: baseStyles.daylightBackground,
    container: baseStyles.container,
  },
  [Theme.MIDNIGHT]: {
    background: baseStyles.midnightBackground,
    container: baseStyles.container,
  },
};

export type ScrollableAreaProps = {
  children: React.ReactNode;
};

export const ScrollableArea = React.memo(({ children }: ScrollableAreaProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        {children}
      </div>
    </div>
  );
});

ScrollableArea.displayName = 'ScrollableArea';
